import _taggedTemplateLiteral from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { Typography } from '@finam/web-ui-kit';
import styled from 'styled-components';
export var Text = styled(Typography).attrs({
  variant: 'h3',
  weight: 'bold'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 24px;\n"])));